
import Vue from 'vue';
import Pagination from '@/components/Pagination/index.vue';
import { TableHeader } from '@/utils/organizeDataForTable';
import { getContestation } from '@/services/contestation/get-contestationPaginate';
import { getContestationAll } from '@/services/contestation/get-contestationAll';
import Table from '@/components/TableAdapter/index.vue';
import { getUserGroup } from '@/utils';
import {
  Wrapper,
} from './styles';

export default Vue.extend({
  components: {
    Wrapper, Table, Pagination,
  },
  data() {
    return {
      territories: [{}] as any,
      userGroup: '',
      loading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      indexTerritories: [] as any,
      digitalSafe: '',
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      headers: [
        { key: 'nameProducer', value: 'Produtor', isOrder: true },
        { key: 'name', value: 'Território', isOrder: true },
        { key: 'city', value: 'Cidade', isOrder: true },
        { key: 'status', value: 'Status', tag: true },
      ] as TableHeader[],
      data: [] as any,
    };
  },
  computed: {
    constation(): any[] {
      return this.territories.map((contest: any) => ({
        name: contest.name,
        car: contest.car,
        status: contest.status,
        cdTerritory: contest.cdTerritory,
        document: contest.document,
        city: contest.city,
        nameProducer: contest.nameProducer,
        type: 'Contastation',
      }));
    },
  },
  methods: {
    click(row) {
      console.log('clicou!!!!', row);
      // this.$router.push(`admin/territorioInfo/${id}/${name}`);
    },
    async getTerritoriesRequest(page = 1) {
      this.loading = true;
      this.userGroup = `${getUserGroup()}`;
      const tokenKey = this.userLoged.company.stKey;
      const total = await getContestationAll(tokenKey);
      this.territories = await getContestation(this.pagination.pageSize, page, tokenKey);
      this.loading = false;
      this.pagination.total = total.length;
    },
    setOffset(page: number) {
      this.pagination.page = page;
      this.getTerritoriesRequest(page);
    },
  },
  created() {
    this.getTerritoriesRequest();
  },
});
